import { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '@reducers/index';
import FadeLoader from 'react-spinners/FadeLoader';
import LoaderComponent from '@components/atom/layout/loader';
import { percentFormatter, integerFormatter } from '@utils/common/formatter';

const InfoBox = () => {
  const { titleObj, titleObjRequestStatus } = useSelector(({ keywordExplore }: RootState) => keywordExplore);
  return (
    <>
      {titleObjRequestStatus === 'pending' ? (
        <LoaderComponent height="75px">
          <FadeLoader />
        </LoaderComponent>
      ) : (
        titleObj && (
          <div className="app-info">
            <ul className="explorer">
              <li className="explorer-type1">
                <span className="explorer-tit">Keyword</span>
                <p className="explorer-data">{titleObj?.keyword}</p>
              </li>
              <li className="explorer-type2">
                <span className="explorer-tit">Search Score</span>
                <p className="explorer-data">{titleObj?.searchscore}</p>
              </li>
              <li className="explorer-type3">
                <span className="explorer-tit">Chance</span>
                <p className="explorer-data">{percentFormatter(titleObj?.chance * 100)}</p>
              </li>
              <li className="explorer-type4">
                <span className="explorer-tit">Total Apps</span>
                <p className="explorer-data">{integerFormatter(titleObj?.totalapps)}</p>
              </li>
            </ul>
          </div>
        )
      )}
    </>
  );
};

export default InfoBox;
